export default __webpack_public_path__ + "static/media/billing.975a6247.svg";